import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5e29a47a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5e29a47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e29a47a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e29a47a')) {
      api.createRecord('5e29a47a', component.options)
    } else {
      api.reload('5e29a47a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5e29a47a&scoped=true&", function () {
      api.rerender('5e29a47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/referral/index.vue"
export default component.exports